import React from 'react';
import { Chip } from '@mui/material';

const StatusBadge = ({ label, color = 'blue' }) => {
    const colorMap = {
        blue: { text: '#1976d2', background: '#bbdefb' },
        green: { text: '#388e3c', background: '#c8e6c9' },
    };

    return (
        <Chip
            label={label}
            sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                backgroundColor: colorMap[color]?.background || '#bbdefb',
                color: colorMap[color]?.text || '#1976d2',
                borderRadius: '12px',
                padding: '4px 12px',
            }}
        />
    );
};

export default StatusBadge;
